module.exports = __webpack_public_path__ + "media/img/frontend_application/vnfc-pay-logo-af5c34f21a5c90caae34161fa17935ed.png";